
import { openPop } from "@/utils/utils"
import { LINK_YUU_TYPE } from "@/constants/auth"
export default {
  name: "LinkYuu",
  data() {
    return {
      accountInfo: {}
    }
  },
  computed: {
    isLink() {
      return this.accountInfo?.yuuId
    }
  },
  mounted() {
    const { isOnline } = this.$utils.getLoginStatus()
    if (isOnline) {
      const accountInfo = localStorage.getItem("accountInfo")
        ? this.$utils.base64Decode(localStorage.getItem("accountInfo"))
        : {}
      this.accountInfo = accountInfo
    }
  },
  methods: {
    handleLink() {
      const phoneWithAreaCode = this.accountInfo.areaCode + " " + this.accountInfo.phone
      openPop("", phoneWithAreaCode, LINK_YUU_TYPE.BIND_YUU)
    }
  }
}
